import {
  GET_GALLERY_FILES,
  SET_GALLERY_PAGE
} from "../../shared/constants/ActionTypes";
import moment from "moment";

const initialBooks = {
  galleryFiles: [],
  count: 0,
  page: 1
};

function GalleryReducer(state = initialBooks, action) {
  switch (action.type) {
    case GET_GALLERY_FILES:
      return {
        ...state,
        galleryFiles: action.payload.media.map((item) => {
          return {
            ...item,
            updatedAtFormatted: moment(item.createdAt).format("ll"),
          };
        }),
        count: action.payload.total,
      };
    case SET_GALLERY_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    default:
      return state;
  }
}

export default GalleryReducer;
